import { ModuleType } from '../../common-constants';

export default class BookingModule {
    public active: boolean;
    public type: ModuleType;

    constructor(json: any) {
        this.active = json.active;
        this.type = json.type as ModuleType;
    }
}
